module.exports = __webpack_public_path__ + "static/img/online_reservation_1.14b9eae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/online_reservation_1.jpg
// module id = 217
// module chunks = 1